import { render, staticRenderFns } from "./Terminos.vue?vue&type=template&id=0218235a&scoped=true"
import script from "./Terminos.vue?vue&type=script&lang=js"
export * from "./Terminos.vue?vue&type=script&lang=js"
import style0 from "./Terminos.vue?vue&type=style&index=0&id=0218235a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0218235a",
  null
  
)

export default component.exports